// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bc-0";
export var headerCellHover = "_bc-1";
export var readCellContainer = "_bc-2";
export var readCellSlot = "_bc-3";
export var rowHoverCheckbox = "_bc-4";
export var rowUnreadIndicator = "_bc-5";
export var searchHighlight = "_bc-8";
export var supportTicketRow = "_bc-6";
export var unreadIndicator = "_bc-7";